import axios from '@api';

/**
 * save feedback
 */
export const saveFeedback = ({ like, tabId }: { like: boolean; tabId: number }) => {
  return axios({
    data: {
      job_item_id: tabId,
      like,
    },
    method: 'post',
    url: '/v2/api/summary/feedback',
    withCredentials: true,
  });
};
